import Matter from 'matter-js';

const {
    Engine, Render, Runner, MouseConstraint, Mouse, Composite, Bodies, Events,
} = Matter;

const colliderArg = {
    height: 384,
    width: 640,
    // eslint-disable-next-line no-undef
    texture: `${wpUrls.template_dir}/assets/img/line.png`,
    bottom: percentY(100) - 196,
};

const arcArg = {
    height: 128,
    width: 256,
    // eslint-disable-next-line no-undef
    texture: `${wpUrls.template_dir}/assets/img/arc.png`,
    bottom: 100,
};

const cubeArg = {
    height: 128,
    width: 128,
    // eslint-disable-next-line no-undef
    texture: `${wpUrls.template_dir}/assets/img/cube.png`,
};

const cubeSmallArg = {
    height: 128,
    width: 64,
    // eslint-disable-next-line no-undef
    texture: `${wpUrls.template_dir}/assets/img/cube-small.png`,
};

let radius = 15;
const tabletBreakpoint = $(document).width() < 821;

if (tabletBreakpoint) {
    colliderArg.height = 152;
    colliderArg.width = 254;
    colliderArg.bottom = percentY(100) - 76;
    // eslint-disable-next-line no-undef
    colliderArg.texture = `${wpUrls.template_dir}/assets/img/mobile/line.png`;

    arcArg.height = 50;
    arcArg.width = 100;
    arcArg.bottom = 100;
    // eslint-disable-next-line no-undef
    arcArg.texture = `${wpUrls.template_dir}/assets/img/mobile/arc.png`;

    cubeArg.height = 50;
    cubeArg.width = 50;
    // eslint-disable-next-line no-undef
    cubeArg.texture = `${wpUrls.template_dir}/assets/img/mobile/cube.png`;

    cubeSmallArg.height = 50;
    cubeSmallArg.width = 25;
    // eslint-disable-next-line no-undef
    cubeSmallArg.texture = `${wpUrls.template_dir}/assets/img/mobile/cube-small.png`;

    radius = 6;
}

function percentX(percent) {
    return Math.round((percent / 100) * window.innerWidth);
}

function percentY(percent) {
    return Math.round((percent / 100) * (window.innerHeight - 204));
}

// create engine
const engine = Engine.create(),
    { world } = engine;
const container = document.getElementById('iglu');

// create renderer
const render = Render.create({
    element: container,
    engine,
    options: {
        wireframes: false,
        showInternalEdges: false,
        width: percentX(100),
        height: percentY(100),
        background: 'transparent'
    }
});
Render.run(render);

// create runner
const runner = Runner.create();
Runner.run(runner, engine);

// bodies array
const bodies = [];
const blocks = [];

// boundaries
const ceiling = Bodies.rectangle(percentX(100) / 2, percentY(0) - 25, percentX(100), 50, {
    isStatic: true,
    label: 'ceiling',
    inArea: true,
});
const floor = Bodies.rectangle(percentX(100) / 2, percentY(100) + 25, percentX(100), 50, {
    label: 'floor',
    isStatic: true,
    inArea: true,
});
const rightWall = Bodies.rectangle(percentX(100) + 25, percentY(100) / 2, 50, percentY(100), {
    isStatic: true,
    label: 'rightWall',
    inArea: true,
});
const leftWall = Bodies.rectangle(percentX(0) - 25, percentY(100) / 2, 50, percentY(100), {
    isStatic: true,
    label: 'leftWall',
    inArea: true,
});
ceiling.render.visible = false;
floor.render.visible = false;
rightWall.render.visible = false;
leftWall.render.visible = false;

bodies.push(ceiling);
bodies.push(floor);
bodies.push(rightWall);
bodies.push(leftWall);

// Collider
const collider = Bodies.rectangle(percentX(100) / 2, colliderArg.bottom, colliderArg.width, colliderArg.height, {
    isSensor: true,
    label: 'collider',
    isStatic: true,
    inArea: true,
    render: {
        fillStyle: 'red',
        sprite: {
            texture: colliderArg.texture
        }
    }
});
collider.inArea = true;
bodies.push(collider);

// Cubes
const arc = Bodies.rectangle(arcArg.width * 2, arcArg.bottom, arcArg.width, arcArg.height, {
    label: 'arc',
    inArea: false,
    density: 0.008,
    friction: 0.8,
    frictionAir: 0.025,
    frictionStatic: 100,
    render: {
        chamfer: { radius },
        sprite: {
            // eslint-disable-next-line no-undef
            texture: arcArg.texture
        }
    }
});

for (let cubeIndex = 0; cubeIndex < 11; cubeIndex++) {
    const side = getRandomArbitrary(cubeArg.width, percentX(100));

    blocks.push(Bodies.rectangle(
        side,
        getRandomArbitrary(cubeArg.height, percentY(100)),
        cubeArg.width,
        cubeArg.height,
        {
            label: 'cube',
            inArea: false,
            chamfer: { radius },
            density: 0.008,
            friction: 0.8,
            frictionAir: 0.025,
            frictionStatic: 50,
            render: {
                sprite: {
                    // eslint-disable-next-line no-undef
                    texture: cubeArg.texture
                }
            }
        }
    ));

    if (cubeIndex < 2) {
        blocks.push(Bodies.rectangle(
            side,
            cubeSmallArg.width * (cubeIndex + 1),
            cubeSmallArg.width,
            cubeSmallArg.height,
            {
                label: 'cube-small',
                inArea: false,
                density: 0.008,
                friction: 0.8,
                frictionAir: 0.025,
                frictionStatic: 20,
                chamfer: { radius },
                render: {
                    sprite: {
                        // eslint-disable-next-line max-len, no-undef
                        texture: cubeSmallArg.texture
                    }
                }
            }
        ));
    }
}

Composite.add(world, bodies);
Composite.add(world, arc);

let restBlocks = blocks;
if (tabletBreakpoint) {
    for (let blockIndex = 0; blockIndex < 4; blockIndex++) {
        const block = blocks[blockIndex];
        Composite.add(world, block);

        restBlocks = restBlocks.filter((blockInBlocks) => blockInBlocks.id !== block.id);
    }

    let clickIndex = 0;
    const moreBlocks = $('.moreBlocks');
    const iglu = $('#iglu');
    moreBlocks.on('click touch', (e) => {
        if (clickIndex === 0) {
            iglu.addClass('active');
            moreBlocks.addClass('more');
            moreBlocks.text('Eisblock');
        } else if (restBlocks.length) {
            Composite.add(world, restBlocks[0]);
            restBlocks = restBlocks.filter((blockInBlocks) => blockInBlocks.id !== restBlocks[0].id);

            if (!restBlocks.length) {
                moreBlocks.addClass('toggle');
                moreBlocks.removeClass('more');
                moreBlocks.text('Bauen deaktivieren');
            }
        } else if ($(e.currentTarget).hasClass('toggle')) {
            iglu.toggleClass('active');
            const moreText = $(e.currentTarget).text();
            $(e.currentTarget).text(moreText === 'Bauen deaktivieren' ? 'Bauen aktivieren' : 'Bauen deaktivieren');
        }

        clickIndex++;
    });
} else {
    Composite.add(world, blocks);
}

// add mouse control
const mouse = Mouse.create(render.canvas),
    mouseConstraint = MouseConstraint.create(engine, {
        mouse,
        constraint: {
            stiffness: 0.2,
            render: {
                visible: false
            }
        }
    });
mouseConstraint.mouse.element.removeEventListener('mousewheel', mouseConstraint.mouse.mousewheel);
mouseConstraint.mouse.element.removeEventListener('DOMMouseScroll', mouseConstraint.mouse.mousewheel);

Composite.add(world, mouseConstraint);

// keep the mouse in sync with rendering
render.mouse = mouse;

Events.on(engine, 'collisionStart', (event) => {
    const { pairs } = event;

    for (let i = 0, j = pairs.length; i !== j; ++i) {
        const pair = pairs[i];
        if (pair.bodyA === collider) {
            blockDetector(pair.bodyB, true);
        } else if (pair.bodyB === collider) {
            blockDetector(pair.bodyA, true);
        }
    }
});

let collisionEndTimeout = null;
Events.on(engine, 'collisionEnd', (event) => {
    const { pairs } = event;

    for (let i = 0, j = pairs.length; i !== j; ++i) {
        const pair = pairs[i];

        if (pair.bodyA === collider) {
            blockDetector(pair.bodyB, false);
        } else if (pair.bodyB === collider) {
            blockDetector(pair.bodyA, false);
        }
    }

    clearTimeout(collisionEndTimeout);
    collisionEndTimeout = setTimeout(() => {
        const allBodies = Composite.allBodies(engine.world);

        if (
            (tabletBreakpoint
            && allBodies.length === allBodies.filter((post) => post.inArea).length
            && !restBlocks.length)
        || (!tabletBreakpoint && allBodies.length === allBodies.filter((post) => post.inArea).length)
        ) {
            blocksDone(true);
        } else {
            blocksDone(false);
        }
    }, 1000);
});

Events.on(mouseConstraint, 'startdrag', () => {
    document.body.classList.add('dragging');
});

Events.on(mouseConstraint, 'enddrag', () => {
    document.body.classList.remove('dragging');
});

// set block detection
const blockDetector = (body, add) => {
    if (add) {
        body.inArea = true;
    } else {
        body.inArea = false;
    }
};

// all blocks are done
const blocksDone = (done) => {
    const igluIcebear = document.getElementById('iglu_icebear');
    const igluBubble = document.getElementById('iglu__bubble');

    if (igluIcebear) {
        if (done) {
            igluIcebear.classList.add('active');
            igluBubble.classList.add('active');

            setTimeout(() => {
                igluIcebear.classList.add('isBlinking');

                setTimeout(() => {
                    igluIcebear.classList.remove('isBlinking');
                }, 500);
            }, 1000);
        } else {
            igluIcebear.classList.remove('active');
            igluBubble.classList.remove('active');
        }
    }
};

// random function
function getRandomArbitrary(min, max) {
    return Math.random() * (max - min) + min;
}
